"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.active.help': 'Inactive knowledge entries are not visible to normal users',
};
